// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MiPerfil — perfil del usuario (aspecto + enlace a la identidad del IdP). */

.perfil-page {
  max-width: 860px;
  margin: 24px auto 48px;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ── Cabecera con el avatar redondo ── */
.perfil-hero {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 22px 24px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl, 16px);
  box-shadow: var(--shadow-sm);
}

.perfil-avatar {
  width: 84px;
  height: 84px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, #6ee7ff, #1a9be6);
  color: #0b1630;
  font-weight: 800;
  font-size: 1.7rem;
  letter-spacing: 1px;
  box-shadow: 0 8px 22px rgba(26, 155, 230, 0.35);
}

.perfil-hero-text {
  min-width: 0;
}

.perfil-name {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.2;
  word-break: break-word;
}

.perfil-email {
  margin: 4px 0 0;
  font-size: 0.92rem;
  color: var(--text-secondary);
  word-break: break-all;
}

.perfil-hero-hint {
  margin: 8px 0 0;
  font-size: 0.8rem;
  color: var(--text-muted);
}

/* ── Tarjetas de sección ── */
.perfil-card {
  padding: 20px 24px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl, 16px);
  box-shadow: var(--shadow-sm);
}

.perfil-card-head {
  margin-bottom: 16px;
}

.perfil-card-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--text-primary);
}

.perfil-card-subtitle {
  margin: 6px 0 0;
  font-size: 0.86rem;
  color: var(--text-secondary);
  line-height: 1.5;
  max-width: 64ch;
}

/* ── Campo genérico ── */
.perfil-field {
  margin-top: 18px;
  max-width: 260px;
}

.perfil-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--text-muted);
}

.perfil-label--spaced {
  margin-top: 12px;
}

.perfil-value {
  display: block;
  margin-top: 3px;
  font-size: 0.92rem;
  color: var(--text-primary);
  word-break: break-word;
}

.perfil-select {
  margin-top: 6px;
  background: var(--bg-input, var(--bg-surface));
  border-color: var(--border);
  color: var(--text-primary);
}

.perfil-hint {
  margin: 6px 0 0;
  font-size: 0.78rem;
  line-height: 1.4;
  color: var(--text-muted);
}

.perfil-hint--error {
  color: #fca5a5;
}

/* ── Identidad ── */
.perfil-identity-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.perfil-identity-data {
  min-width: 0;
}

.perfil-idp-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 10px;
  background: var(--accent);
  border: 1px solid var(--accent);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.15s ease, filter 0.15s ease;
}

.perfil-idp-btn:hover {
  color: #fff;
  transform: translateY(-1px);
  filter: brightness(1.06);
}

.perfil-idp-btn.is-pending {
  opacity: 0.7;
}

.perfil-idp-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.perfil-idp-host {
  margin: 14px 0 0;
  font-size: 0.78rem;
  color: var(--text-muted);
}

.perfil-idp-host code {
  color: var(--text-secondary);
}

/* ── Acciones ── */
.perfil-actions {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: flex-end;
}

.perfil-logout-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 10px;
  background: rgba(220, 38, 38, 0.1);
  border: 1px solid rgba(220, 38, 38, 0.32);
  color: #ef4444;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.perfil-logout-btn:hover {
  background: rgba(220, 38, 38, 0.18);
  border-color: rgba(220, 38, 38, 0.5);
}

.perfil-logout-icon {
  width: 17px;
  height: 17px;
}

@media (max-width: 640px) {
  .perfil-page {
    margin-top: 14px;
    padding: 0 10px;
  }

  .perfil-hero {
    padding: 16px;
    gap: 14px;
  }

  .perfil-avatar {
    width: 64px;
    height: 64px;
    font-size: 1.25rem;
  }

  .perfil-name {
    font-size: 1.2rem;
  }

  .perfil-card {
    padding: 16px;
  }

  .perfil-idp-btn {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MiPerfil.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* MiPerfil — perfil del usuario (aspecto + enlace a la identidad del IdP). */\r\n\r\n.perfil-page {\r\n  max-width: 860px;\r\n  margin: 24px auto 48px;\r\n  padding: 0 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n}\r\n\r\n/* ── Cabecera con el avatar redondo ── */\r\n.perfil-hero {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n  padding: 22px 24px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-xl, 16px);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.perfil-avatar {\r\n  width: 84px;\r\n  height: 84px;\r\n  border-radius: 999px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  background: linear-gradient(135deg, #6ee7ff, #1a9be6);\r\n  color: #0b1630;\r\n  font-weight: 800;\r\n  font-size: 1.7rem;\r\n  letter-spacing: 1px;\r\n  box-shadow: 0 8px 22px rgba(26, 155, 230, 0.35);\r\n}\r\n\r\n.perfil-hero-text {\r\n  min-width: 0;\r\n}\r\n\r\n.perfil-name {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n  line-height: 1.2;\r\n  word-break: break-word;\r\n}\r\n\r\n.perfil-email {\r\n  margin: 4px 0 0;\r\n  font-size: 0.92rem;\r\n  color: var(--text-secondary);\r\n  word-break: break-all;\r\n}\r\n\r\n.perfil-hero-hint {\r\n  margin: 8px 0 0;\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Tarjetas de sección ── */\r\n.perfil-card {\r\n  padding: 20px 24px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-xl, 16px);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.perfil-card-head {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.perfil-card-title {\r\n  margin: 0;\r\n  font-size: 1.05rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.perfil-card-subtitle {\r\n  margin: 6px 0 0;\r\n  font-size: 0.86rem;\r\n  color: var(--text-secondary);\r\n  line-height: 1.5;\r\n  max-width: 64ch;\r\n}\r\n\r\n/* ── Campo genérico ── */\r\n.perfil-field {\r\n  margin-top: 18px;\r\n  max-width: 260px;\r\n}\r\n\r\n.perfil-label {\r\n  display: block;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.4px;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.perfil-label--spaced {\r\n  margin-top: 12px;\r\n}\r\n\r\n.perfil-value {\r\n  display: block;\r\n  margin-top: 3px;\r\n  font-size: 0.92rem;\r\n  color: var(--text-primary);\r\n  word-break: break-word;\r\n}\r\n\r\n.perfil-select {\r\n  margin-top: 6px;\r\n  background: var(--bg-input, var(--bg-surface));\r\n  border-color: var(--border);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.perfil-hint {\r\n  margin: 6px 0 0;\r\n  font-size: 0.78rem;\r\n  line-height: 1.4;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.perfil-hint--error {\r\n  color: #fca5a5;\r\n}\r\n\r\n/* ── Identidad ── */\r\n.perfil-identity-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.perfil-identity-data {\r\n  min-width: 0;\r\n}\r\n\r\n.perfil-idp-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  border-radius: 10px;\r\n  background: var(--accent);\r\n  border: 1px solid var(--accent);\r\n  color: #fff;\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  text-decoration: none;\r\n  transition: transform 0.15s ease, filter 0.15s ease;\r\n}\r\n\r\n.perfil-idp-btn:hover {\r\n  color: #fff;\r\n  transform: translateY(-1px);\r\n  filter: brightness(1.06);\r\n}\r\n\r\n.perfil-idp-btn.is-pending {\r\n  opacity: 0.7;\r\n}\r\n\r\n.perfil-idp-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.perfil-idp-host {\r\n  margin: 14px 0 0;\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.perfil-idp-host code {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ── Acciones ── */\r\n.perfil-actions {\r\n  margin-top: 18px;\r\n  padding-top: 16px;\r\n  border-top: 1px solid var(--border);\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.perfil-logout-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 9px 16px;\r\n  border-radius: 10px;\r\n  background: rgba(220, 38, 38, 0.1);\r\n  border: 1px solid rgba(220, 38, 38, 0.32);\r\n  color: #ef4444;\r\n  font-size: 0.88rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.perfil-logout-btn:hover {\r\n  background: rgba(220, 38, 38, 0.18);\r\n  border-color: rgba(220, 38, 38, 0.5);\r\n}\r\n\r\n.perfil-logout-icon {\r\n  width: 17px;\r\n  height: 17px;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .perfil-page {\r\n    margin-top: 14px;\r\n    padding: 0 10px;\r\n  }\r\n\r\n  .perfil-hero {\r\n    padding: 16px;\r\n    gap: 14px;\r\n  }\r\n\r\n  .perfil-avatar {\r\n    width: 64px;\r\n    height: 64px;\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .perfil-name {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .perfil-card {\r\n    padding: 16px;\r\n  }\r\n\r\n  .perfil-idp-btn {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
